import WebSocket from 'isomorphic-ws';
import { Operation as LoggingOperation, Log, LogCategory } from '@augloop/logging';
import { LogCountLimiter } from '../utils';
export class WebSocketWorker {
    constructor() {
        this.hadEgressError = false;
        this.isClosing = false;
        // All request messages will be put into this array before the WebSocket becomes open.
        this.pendingEgress = [];
    }
    init(url, ingress, onOpen, onClose) {
        this.ws = new WebSocket(url);
        this.logOp = new LoggingOperation({ operationName: WebSocketWorker.className, success: true }).start();
        this.ingressByteCountOp = new LoggingOperation({ operationName: 'WSIngressByteOrderOfMagnitude', success: true });
        this.ws.addEventListener('open', _event => {
            onOpen();
            WebSocketWorker.logCountLimiter.log(() => {
                this.logOp.resourceId = 'OnOpen';
                this.logOp.resultDescription = '';
                this.logOp.success = true;
                this.logOp.dimension0 = this.pendingEgress.length.toString();
                Log.info(0x1e545719 /* tag_4vf2z */, LogCategory.CoreDefault, this.logOp.stop());
            });
        });
        this.ws.addEventListener('message', event => {
            this.logIngressCount(event.data);
            ingress(event.data);
        });
        this.ws.addEventListener('error', event => {
            this.errorMessage = event.message;
            WebSocketWorker.logCountLimiter.log(() => {
                this.logOp.resourceId = 'OnError';
                this.logOp.resultDescription = this.errorMessage;
                this.logOp.success = false;
                Log.info(0x1e545718 /* tag_4vf2y */, LogCategory.CoreDefault, this.logOp.stop());
            });
            this.ws.close();
        });
        this.ws.addEventListener('close', event => {
            WebSocketWorker.logCountLimiter.log(() => {
                this.logOp.resourceId = 'OnClose';
                this.logOp.resultDescription = event ? `code: ${event.code}. reason: ${event.reason}` : '';
                this.logOp.success = true;
                Log.info(0x1e545717 /* tag_4vf2x */, LogCategory.CoreDefault, this.logOp.stop());
            });
            onClose(this.errorMessage);
            this.isClosing = false;
        });
    }
    egress(message) {
        const obj = message.obj;
        this.ws.send(obj, (err) => {
            if (err && !this.hadEgressError) {
                this.hadEgressError = true;
                WebSocketWorker.logCountLimiter.log(() => {
                    this.logOp.resourceId = 'OnEgressError';
                    this.logOp.resultDescription = err.message;
                    this.logOp.success = false;
                    Log.info(0x1e545715 /* tag_4vf2v */, LogCategory.CoreDefault, this.logOp.stop());
                });
            }
        });
    }
    close() {
        if (this.isClosing) {
            return;
        }
        this.isClosing = true;
        this.ws.close();
    }
    logIngressCount(obj) {
        const byteCount = obj.length;
        if (byteCount > 100000) {
            this.ingressByteCountOp.start();
            this.ingressByteCountOp.dimension2 = byteCount.toString().length.toString();
            Log.info(0x1e545712 /* tag_4vf2s */, LogCategory.CoreDefault, this.ingressByteCountOp.stop());
        }
    }
}
WebSocketWorker.className = 'WebSocketWorker';
WebSocketWorker.logCountLimiter = new LogCountLimiter(WebSocketWorker.className);
//# sourceMappingURL=websocket-worker.js.map